// Nothing else should ever use these values. So define here only:
const JE_AUSER_COOKIE = 'je-auser';
const LOG_TAGS = 'user-identifier';

const userIdentifier = ({
    $cookies,
    store,
    $log
}) => {
    // Should always be present as it is set in the cf-worker
    const identifier = $cookies.get(JE_AUSER_COOKIE);

    $log.info(`Dispatching Anonymous User Identifier: ${identifier}`, LOG_TAGS);
    store.dispatch(
        'jeUserCookie/setJeUserCookie',
        identifier
    );
};

export default userIdentifier;
